import React, { useState } from "react";

import Text from '../Text';

import styles from "./index.module.css";

import tickIcon from "../../assets/icons/checkbox/tick.svg";
import untickIcon from "../../assets/icons/checkbox/untick.svg";

function Checkbox(props) {
  const { text, className, id } = props;

  const [checked, setChecked] = useState(false);

  const checkClick = () => {
    setChecked(!checked);
    props.onClick();
  }

  return (
    <button
      className={`${styles['checkbox']} ${className}`}
      onClick={checkClick}
      id={id}
    >
      <img src={ checked ? tickIcon : untickIcon } alt="" />
      <Text type="l24">
        {text}
      </Text>
    </button>
  );
}

export default Checkbox;
